module.exports = "img/placeholder.b945544.png";